import {
  NotificationSubscription,
  NotificationChannel,
  NotificationChannelEnum,
} from "@jasper/client-models";
import {
  Box,
  Stack,
  type StackProps,
  Switch,
  Text,
  Tooltip,
} from "@mantine/core";

interface Props extends Omit<StackProps, "onChange" | "children"> {
  subscriptions: NotificationSubscription;
  isLoading?: boolean;
  onChange: (notificationChannel: NotificationChannel, value: boolean) => void;
}

export const NotificationSubscriptions = ({
  onChange,
  subscriptions,
  isLoading,
  ...props
}: Props) => {
  return (
    <Stack {...props}>
      <Switch
        label={<Text fw={500}>SMS</Text>}
        checked={subscriptions.SMS ?? false}
        disabled={isLoading}
        onChange={e =>
          onChange(NotificationChannelEnum.SMS, e.currentTarget.checked)
        }
      />
      <Tooltip
        label="Cette option n'est pas encore disponible"
        withArrow
        position="right"
      >
        <Box w="fit-content">
          <Switch
            disabled
            checked={subscriptions.EMAIL ?? false}
            onChange={e =>
              onChange(NotificationChannelEnum.EMAIL, e.currentTarget.checked)
            }
            label={
              <Text fw={500} c="gray">
                Email
              </Text>
            }
          />
        </Box>
      </Tooltip>
      <Tooltip
        label="Cette option n'est pas encore disponible"
        withArrow
        position="right"
      >
        <Box w="fit-content">
          <Switch
            disabled
            checked={subscriptions.PUSH ?? false}
            onChange={e =>
              onChange(NotificationChannelEnum.PUSH, e.currentTarget.checked)
            }
            label={
              <Text fw={500} c="gray">
                Push
              </Text>
            }
          />
        </Box>
      </Tooltip>
    </Stack>
  );
};
